import { addGradient } from './style'

const addExternalAria = (el) => {
  const links = el.querySelectorAll('a')
  Array.from(links).forEach((link) => {
    if (link.target === '_blank') {
      link.setAttribute('aria-label', 'link opens in new tab or window')
    }
  })
  return el[el.classList.contains('has-table') ? 'outerHTML' : 'innerHTML'].toString()
}

const addTableClasses = (el) => {
  el.classList.add(el.querySelectorAll('table').length > 0 ? 'has-table' : 'no-table')
  return el
}

const createMarkup = (markup) => {
  let el = document.createElement('div')
  el.innerHTML = markup
  el = addTableClasses(el)
  return { __html: addExternalAria(el) }
}

const createGradientElement = ({ type, fromColor, fullMobile = false, classes = '' }) => {
  if (!type || !fromColor) {
    return
  }
  return (
    <div
      style={{ '--gradient-from': fromColor }}
      className={`cua--gradient z-0 ${addGradient(type, fullMobile)} ${classes}`}
      aria-hidden="true"
    />
  )
}

export { createMarkup, createGradientElement }
